import { render } from "./SidebarLink.vue?vue&type=template&id=75271c6c&ts=true"
import script from "./SidebarLink.vue?vue&type=script&lang=ts"
export * from "./SidebarLink.vue?vue&type=script&lang=ts"

import "./SidebarLink.vue?vue&type=style&index=0&id=75271c6c&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__